"use strict";
const moment = require('moment');
const lodash_1 = require('lodash');
const m = require('./models');
const taskUtils = require('./utils/task');
let viewTasksCache = {};
const getTasks = (state) => state.tasks.tasks || {};
const getTaskSessionsByDate = (state, taskId) => (state.sessions.sessions && state.sessions.sessions[taskId]) || {};
const getTask = (state, taskId) => getTasks(state)[taskId];
exports.viewTaskToTask = (_task) => {
    const task = lodash_1.cloneDeep(_task);
    delete task.activeSession;
    delete task.durationOfCompleteSessions;
    delete task.history;
    delete task.msLeftForGoal;
    return task;
};
exports.tasksSelector = (state) => {
    const tasks = getTasks(state);
    return Object.keys(tasks).map(taskId => exports.taskSelector(state, taskId));
};
exports.taskSelector = (state, taskId) => {
    const tasks = getTasks(state);
    const task = tasks[taskId] || m.buildTask();
    const sessionsByDate = getTaskSessionsByDate(state, taskId);
    return buildViewTask(task, sessionsByDate);
};
const buildViewTask = (task, sessionsByDate = {}) => {
    const sessionsTodayById = sessionsByDate[moment().format('YYYY-MM-DD')] || {};
    const sessionsToday = Object.keys(sessionsTodayById).map(id => sessionsTodayById[id]);
    const activeSession = getActiveSession(sessionsToday);
    const durationOfCompleteSessions = taskUtils.sumSessionDurations(sessionsToday, true);
    const history = taskUtils.buildTaskHistory(task, sessionsByDate);
    const msLeftForGoal = taskUtils.getMillisecondsLeftForGoal(task.goal, durationOfCompleteSessions);
    return Object.assign({}, task, {
        activeSession,
        durationOfCompleteSessions,
        history,
        msLeftForGoal,
    });
};
const getActiveSession = (sessions = []) => lodash_1.find(sessions, session => !session.stoppedAt);



/** WEBPACK FOOTER **
 ** ./src/selectors.ts
 **/